import { convertDateToUserLocal } from '../shared/helper'

export function getIDPSessionState(dateString) {
  // Mind server time
  const lastActivity = new Date(convertDateToUserLocal(dateString))
  const now = new Date()
  const diff = now - lastActivity
  const minutes = Math.floor(diff / 1000 / 60)

  if (minutes < 15) {
    return 1
  }
  else if (minutes < 60) {
    return 2
  }
  else if (minutes < 240) {
    return 3
  }
  else {
    return 4
  }
}



// WEBPACK FOOTER //
// ./src/components/idpUser/helper.js